module.exports = __webpack_public_path__ + "media/images/top-content-img-4-6a65faa22d5ad061c9a60e6b64e98b98.jpg";